<template>
    <transition name='modal'>
        <div class="modal-transition modal-mask notification" v-if="modal.show" @click='hideModal'>
            <div class="modal-confirm" @click='prevent'>
                <div class="modal-content">
                    <!--内容区域-->
                    <div class="modal-body">
                        <slot name="body">
                            默认内容 可通过slot分发自定义
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['modal', 'header'],
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
        prevent (e) {
          e.stopPropagation() // 阻止冒泡
        },
        hideModal () {
            this.$set(this.modal, 'show', false)
        }
    }
}
</script>

<style lang='less'>
.modal-mask{ 
    z-index: 99999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(55,55,55,.6);
    display: flex;
    align-items: center;
    color: #333;
    justify-content: center;
    .modal-confirm{
        background-color: white;
        border-radius: 5px;
        min-width: 1000px;
        min-height: 800px;
        .modal-header{
            padding: 20px;
            font-size: 20px;
        }
        .modal-body{
            padding: 20px;
            box-sizing: border-box;
            background-color: #eee;
            min-height: 125px;
            width: 1400px;
        }
        .modal-footer{
            text-align: center;
            padding-bottom: 30px;
            button + button{
                margin-left: 30px;
            }
        }
    }
}
.modal-enter-active {
    transition: all .3s ease;
}
.modal-leave-active{
    transition: all .3s ease;
}
.modal-enter,
.modal-leave-active {
    opacity: 0;
    transform: scale(1.5);
}
</style>



// WEBPACK FOOTER //
// modal.vue?1fb8eeba